<div class="top_nav sticky-header sticky-header-media">
  <div class="nav_menu">
    <nav class="navbar navbar-light header-navbar" aria-label="Top app bar">
      <div class="header-left">
        <button type="button" class="icon-button menu-button" aria-label="Open navigation drawer" (click)="showNav($event)">
          <i class="fa" [ngClass]="show_nav ? 'fa-times' : 'fa-bars'" aria-hidden="true"></i>
        </button>
        <a class="brand-link" routerLink="/dashboard" aria-label="Go to dashboard">
          <img src="assets/images/logo_final1_white.png" alt="AMALY logo" class="brand-logo">
        </a>
        <div class="header-title-group">
          <p class="header-kicker">Admin</p>
        </div>
      </div>

      <div class="header-right">
        <div class="user-menu-wrapper">
          <button type="button" class="user-menu-trigger" id="userDropdown" role="button" (click)="toggleUserMenu($event)" [attr.aria-expanded]="isUserMenuOpen" aria-haspopup="true" aria-label="Open user menu">
            <img class="img-profile" src="assets/image/profile.jpg" alt="User profile">
          </button>

          <div class="user-dropdown-menu" *ngIf="isUserMenuOpen" aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#" (click)="changePassword($event)">
              <i class="fa fa-cog" aria-hidden="true"></i>
              <span>Change Password</span>
            </a>
            <a class="dropdown-item" href="#" (click)="logout($event)">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span>Logout</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>
